import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, getTestId } from '@airtel/air-design-system';
import { View } from 'react-native';
import { getCompareListFooterStyles } from './CompareListFooterStyles';
var CompareListFooter = props => {
  var _props$itemsCount = props.itemsCount,
    itemsCount = _props$itemsCount === void 0 ? 0 : _props$itemsCount,
    showExpandCta = props.showExpandCta,
    _props$expandCtaData = props.expandCtaData,
    expandCtaData = _props$expandCtaData === void 0 ? {} : _props$expandCtaData,
    _props$showFullList = props.showFullList,
    showFullList = _props$showFullList === void 0 ? false : _props$showFullList,
    toggleShowFullList = props.toggleShowFullList,
    style = props.style,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'CompareListFooter' : _props$testID;
  var _expandCtaData$expand = expandCtaData.expandedCtaTitle,
    expandedCtaTitle = _expandCtaData$expand === void 0 ? 'View More Details' : _expandCtaData$expand,
    _expandCtaData$collap = expandCtaData.collapseCtaTitle,
    collapseCtaTitle = _expandCtaData$collap === void 0 ? 'Show Less' : _expandCtaData$collap,
    _expandCtaData$initia = expandCtaData.initialItemCount,
    initialItemCount = _expandCtaData$initia === void 0 ? 8 : _expandCtaData$initia,
    _expandCtaData$expand2 = expandCtaData.expandedIconName,
    expandedIconName = _expandCtaData$expand2 === void 0 ? 'DownChevronButtonIcon' : _expandCtaData$expand2,
    _expandCtaData$collap2 = expandCtaData.collapseIconName,
    collapseIconName = _expandCtaData$collap2 === void 0 ? 'UpChevronButtonIcon' : _expandCtaData$collap2;
  var shouldShowViewMoreButton = itemsCount > initialItemCount;
  var listFooterComponentStyles = shouldShowViewMoreButton && showExpandCta;
  var compareListFooterStyles = getCompareListFooterStyles();
  return _jsx(_Fragment, {
    children: listFooterComponentStyles && _jsx(View, Object.assign({
      style: [compareListFooterStyles.ctaOnContainer, style]
    }, getTestId(testID), {
      children: shouldShowViewMoreButton && showExpandCta && _jsx(Button, Object.assign({
        buttonType: "tertiary",
        size: "md",
        version: "variable-width",
        iconPosition: "right",
        onPress: toggleShowFullList,
        title: showFullList ? collapseCtaTitle : expandedCtaTitle,
        iconName: showFullList ? collapseIconName : expandedIconName
      }, getTestId(testID, 'cta')))
    }))
  });
};
export default CompareListFooter;